import { styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { PAGE_BACKGROUND } from '@theme';
import { CoreBox } from '@youscience/core';

import DoneAllIcon from '@images/Recommender/done-all.svg?react';

export const StyledJustifiedBox = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  alignSelf: 'stretch',
  alignItems: 'center',
  alignContent: 'flex-start',
  justifyContent: 'space-between',
  flexDirection: 'row',

  [theme.breakpoints.down('md')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
}));

export const StyledRecommenders = styled(CoreBox)(() => ({
  display: 'flex',
  padding: '1rem',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '1.5rem',
  marginTop: '1.5rem',
  alignSelf: 'stretch',
  borderRadius: '0.25rem',
  border: `1px solid ${coreThemeColors.grey[300]}`,
  background: PAGE_BACKGROUND,
}));

export const StyledRecommendersTitle = styled(CoreBox)(() => ({
  flex: '1 0 0',
}));

export const StyledTeacherButtonGroup = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  gap: '0.25rem',

  [theme.breakpoints.down('md')]: {
    alignSelf: 'stretch',
  },
}));

export const StyledTeacherCountGroup = styled(CoreBox)(() => ({
  display: 'flex',
  gap: '2rem',
}));

export const StyledTooltipBox = styled(CoreBox)(() => ({
  display: 'flex',
  gap: '0.5rem',
}));

export const StyledDoneAllIcon = styled(DoneAllIcon)(() => ({
  fill: coreThemeColors.primary.main,
}));
